import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from "./login/login.component";
import { FlexLayoutModule } from '@angular/flex-layout';
import { materialModule } from '../material.module';
import { SharedModule } from "./shared.module";

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'projects', loadChildren: () => import(`./projects/projects-router.module`).then(m => m.ProjectsRoutingModule) }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    materialModule,
    FlexLayoutModule,
    SharedModule
  ],
  declarations: [LoginComponent],
  exports: [RouterModule]
})

export class CoreRoutingModule { }
